import { useRef, useState } from 'react';
import {
  ModalHeader,
  ModalContent,
  ModalActions,
  Button,
  Modal,
  ModalDescription,
  Icon,
} from 'semantic-ui-react';
import AGTable from '../../../components/table/aggrid';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { screenSizes } from 'src/assets/styles/Literals';

export const MemberDetailPieModal = ({ group, list, open, setOpen }) => {
  const gridRef = useRef(null);
  const [countVisible, setCountVisible] = useState(0);

  // Define column definitions for AG Grid
  const columnDefs = [
    {
      headerName: 'Nombre',
      field: 'fullName',
      cellRenderer: (params) => {
        const { name, lastName, identification, phone } = params.data;
        return (
          <a
            href={`${window.location.origin}/perfil/crecer?identification=${identification}&phone=${phone}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ cursor: 'pointer', color: '#0066cc', textDecoration: 'underline' }}
          >
            {name} {lastName}
          </a>
        );
      },
      sortable: true,
      filter: true,
      flex: 2,
      minWidth: 150,
    },
    {
      headerName: 'Identificación',
      field: 'identification',
      sortable: true,
      filter: true,
      flex: 1.5,
      minWidth: 120,
    },
    {
      headerName: 'Teléfono',
      field: 'phone',
      sortable: true,
      filter: true,
      flex: 1.2,
      minWidth: 100,
    },
    {
      headerName: 'Email',
      field: 'email',
      sortable: true,
      filter: true,
      flex: 2,
      minWidth: 180,
    },
    {
      headerName: 'Edad',
      field: 'age',
      sortable: true,
      filter: 'agNumberColumnFilter',
      flex: 0.8,
      minWidth: 70,
    },
    {
      headerName: 'Ocupación',
      field: 'occupation',
      sortable: true,
      filter: true,
      flex: 1.5,
      minWidth: 120,
    },
  ];

  // Transform data for AG Grid
  const rowData =
    list?.map((item) => ({
      ...item,
      fullName: `${item.name} ${item.lastName}`,
      occupation: item.occupation || item.ocupation || '',
    })) || [];

  const exportToExcel = () => {
    const dataToExport = list.map((item) => ({
      Nombre: `${item.name} ${item.lastName}`,
      Identificación: item.identification,
      Teléfono: item.phone,
      Email: item.email,
      Edad: item.age,
      Ocupación: item.occupation || item.ocupation || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Discípulos');

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
    });

    const fileName = `discípulos_grupo_${group}.xlsx`;
    const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(fileData, fileName);
  };

  const onGridReady = (params) => {
    if (gridRef.current) {
      gridRef.current.api = params.api;
      gridRef.current.columnApi = params.columnApi;
      if (window.innerWidth > screenSizes.tablet) {
        params.api.sizeColumnsToFit();
      }
      const newDisplayedRowCount = gridRef?.current?.api?.paginationGetRowCount();
      setCountVisible(newDisplayedRowCount);
    }
  };

  const onFilterChanged = () => {
    const newDisplayedRowCount = gridRef?.current?.api?.paginationGetRowCount();
    setCountVisible(newDisplayedRowCount);
  };

  return (
    <Modal size="large" onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open={open}>
      <ModalHeader>Discípulos del grupo {group}.</ModalHeader>
      <ModalDescription>
        <p style={{ padding: '2rem 0 0 2rem', fontSize: '1.2rem' }}>
          Total de discípulos: {list?.length || 0}
        </p>
        <p style={{ padding: '0 0 0 2rem', fontSize: '1.2rem' }}>
          Total de discípulos en pantalla: {countVisible}
        </p>
      </ModalDescription>
      <ModalContent scrolling>
        {list && list.length > 0 ? (
          <div style={{ height: '60vh', width: '100%' }}>
            <AGTable
              columnDefs={columnDefs}
              rowData={rowData}
              tableRef={gridRef}
              onGridReady={onGridReady}
              pagination
              paginationPageSize={20}
              suppressDragLeaveHidesColumns={false}
              onFilterChanged={onFilterChanged}
            />
          </div>
        ) : (
          <p>No hay detalles para mostrar.</p>
        )}
      </ModalContent>
      <ModalActions>
        <Button color="green" onClick={exportToExcel}>
          <Icon name="download" />
          Descargar Excel
        </Button>
        <Button color="black" onClick={() => setOpen(false)}>
          Cerrar
        </Button>
      </ModalActions>
    </Modal>
  );
};
